/**
 * ISO ("2026-10-15") -> "15.10.2026", for DateField. A plain string split,
 * not `new Date(iso)`: a bare "YYYY-MM-DD" parses as UTC midnight, which
 * prints the previous day in a negative-UTC-offset timezone. Same as
 * champis-exhibitions' own formatDate().
 */
export default function formatDate(iso) {
  if (!iso) return iso;
  const [year, month, day] = iso.split('-');
  if (!year || !month || !day) return iso;
  return `${day}.${month}.${year}`;
}
flarum.reg.add('champis-events', 'forum/utils/formatDate', formatDate);